import { queryOptions } from "@tanstack/react-query";
import { apiBase, apiUrl } from "@/lib/api-url";

export const blogPostsQueryOptions = (filters?: {
  status?: string;
  authorId?: string;
  therapistId?: string;
  category?: string;
  q?: string;
  page?: number;
  limit?: number;
}) =>
  queryOptions({
    // "list" je u SSR allowlisti (dehydrate-public.ts), pa /blog i početna
    // bilježe zavisnost i upis bloga ih može izbaciti iz SSR keša.
    queryKey: ["blog", "list", filters],
    queryFn: async () => {
      const url = new URL("/api/blog", apiBase());
      if (filters?.status) url.searchParams.set("status", filters.status);
      if (filters?.authorId) url.searchParams.set("authorId", filters.authorId);
      if (filters?.therapistId) url.searchParams.set("therapistId", filters.therapistId);
      if (filters?.category) url.searchParams.set("category", filters.category);
      if (filters?.q) url.searchParams.set("q", filters.q);
      if (filters?.page) url.searchParams.set("page", String(filters.page));
      if (filters?.limit) url.searchParams.set("limit", String(filters.limit));
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch blog posts");
      return res.json();
    },
  });

export const blogPostQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ["blog", "posts", slug],
    queryFn: async () => {
      const res = await fetch(apiUrl(`/api/blog/${slug}`));
      if (!res.ok) throw new Error("Blog post not found");
      return res.json();
    },
  });

export const blogPostByIdQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["blog", "post-by-id", id],
    queryFn: async () => {
      const res = await fetch(apiUrl(`/api/blog/post/${id}`));
      if (!res.ok) throw new Error("Blog post not found");
      return res.json();
    },
  });
